export const PAGE_TRANSLATION_KEY = 'custom-bundle';

export const getLocales = ({
  extraKeys,
}: {
  extraKeys: { [key: string]: string };
}) => ({
  es: {
    translation: {
      COURSE_PACK_TITLE: `Elige tus cursos`,
      CLEAN_FILTERS: 'Limpiar filtros',
      BANNER_COURSE_PACK_CLEAN: 'Limpiar selección',
      BANNER_COURSE_PACK_RECOMMENDATION: 'Recomiéndame cursos',
      COURSE_BANNER_PACK_BUTTON: 'Llévatelos por',
      ORDER_BY_LABEL: 'Ordenar',
      FILTER_LABEL: 'Filtrar',
      SEARCH_PLACEHOLDER: 'Buscar cursos',
      SEARCH_PLACEHOLDER_2: 'Busca tus cursos preferidos',
      TIMER_TITLE_1: '¡Quedan menos de dos horas!',
      TIMER_TITLE_2: 'La oferta termina en:',
      SHOW_RESULTS: 'Ver resultados',
      CATEGORIES: 'Categorías',
      LEVELS: 'Niveles',
      SOFTWARES: 'Softwares',
      LANGUAGES: 'Idiomas',
      REMOVE_COURSE_FROM_PACK: 'Quitar curso',
      ADD_COURSE_TO_PACK: 'Agregar curso',
      NO_RESULTS: 'No encontramos resultados para tu búsqueda',
      ...extraKeys,
    },
  },
  pt: {
    translation: {
      COURSE_PACK_TITLE: `Escolha seus cursos`,
      CLEAN_FILTERS: 'Filtros limpos',
      BANNER_COURSE_PACK_CLEAN: 'Limpar seleção',
      BANNER_COURSE_PACK_RECOMMENDATION: 'Recomende-me cursos',
      COURSE_BANNER_PACK_BUTTON: 'Leve-os',
      ORDER_BY_LABEL: 'Organizar',
      FILTER_LABEL: 'Filtrar',
      SEARCH_PLACEHOLDER: 'Pesquisar cursos',
      SEARCH_PLACEHOLDER_2: 'Procure seus cursos preferidos',
      TIMER_TITLE_1: '¡Restam menos de dois horas!',
      TIMER_TITLE_2: 'A oferta termina em:',
      SHOW_RESULTS: 'Veja os resultados',
      CATEGORIES: 'Categorías',
      LEVELS: 'Nível',
      SOFTWARES: 'Softwares',
      LANGUAGES: 'Idiomas',
      ADD_COURSE_TO_PACK: 'Adicionar curso',
      REMOVE_COURSE_FROM_PACK: 'Retirar curso',
      NO_RESULTS: 'Não encontramos resultados para sua pesquisa',
      ...extraKeys,
    },
  },
});
